import styled from 'styled-components';
import {COLOR} from '../../constants';

export const ButtonDeleteContainer = styled.button`
  /* Button reset styles */
  border: none;
  background: transparent;
  padding: 0;
  font: inherit;

  /* Original styles */
  color: ${COLOR.TEXT}77;
  cursor: pointer;
  height: 100%;
  text-decoration: none;

  &:before{
    content: "\f2ed";
    font-family: 'Font Awesome 6 Pro';
  }

  &:hover{
    color:${({hoverColor}) => hoverColor ? hoverColor : COLOR.CLOSE};
  }

  /* Focus styles for keyboard accessibility */
  &:focus {
    outline: none;
    color:${({hoverColor}) => hoverColor ? hoverColor : COLOR.CLOSE};
    box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.2);
  }

  &:focus:not(:focus-visible) {
    box-shadow: none;
  }
`;